import { render, staticRenderFns } from "./InPageNav.vue?vue&type=template&id=2c5968a3&"
import script from "./InPageNav.vue?vue&type=script&lang=js&"
export * from "./InPageNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports